import React from 'react';
import { useParams } from 'react-router-dom';
import { Loader2, MailX, CheckCircle2 } from 'lucide-react';
import { publicMarketingApi } from '../../lib/api';

export const MarketingUnsubscribePage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const [companyName, setCompanyName] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState('');
    const [done, setDone] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    React.useEffect(() => {
        if (!token) return;
        publicMarketingApi.getInfo(token).then((d: any) => {
            if (d?.error) { setError(d.error); return; }
            setCompanyName(d.company_name || '');
            setDone(!!d.already_unsubscribed);
        }).catch(() => setError('Lien invalide.')).finally(() => setLoading(false));
    }, [token]);

    const handleUnsubscribe = async () => {
        if (!token) return;
        setSubmitting(true);
        try {
            const res: any = await publicMarketingApi.unsubscribe(token);
            if (res?.error) { setError(res.error); return; }
            setDone(true);
        } catch {
            setError("Erreur lors du désabonnement.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9', fontFamily: 'Arial, Helvetica, sans-serif', padding: 16 }}>
            <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
                {loading ? (
                    <Loader2 className="animate-spin" style={{ margin: '0 auto', color: '#94a3b8' }} size={28} />
                ) : error ? (
                    <p style={{ color: '#dc2626', fontSize: 14 }}>{error}</p>
                ) : done ? (
                    <>
                        <CheckCircle2 size={40} style={{ color: '#16a34a', margin: '0 auto 12px' }} />
                        <h1 style={{ fontSize: 18, fontWeight: 900, color: '#0f172a', margin: '0 0 8px' }}>Désabonnement confirmé</h1>
                        <p style={{ fontSize: 13, color: '#64748b' }}>Vous ne recevrez plus d'emails publicitaires{companyName ? ` de ${companyName}` : ''}.</p>
                    </>
                ) : (
                    <>
                        <MailX size={40} style={{ color: '#94a3b8', margin: '0 auto 12px' }} />
                        <h1 style={{ fontSize: 18, fontWeight: 900, color: '#0f172a', margin: '0 0 8px' }}>Se désabonner{companyName ? ` de ${companyName}` : ''}</h1>
                        <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>Vous ne recevrez plus d'emails publicitaires de cet établissement.</p>
                        <button onClick={handleUnsubscribe} disabled={submitting}
                            style={{ background: '#dc2626', color: '#fff', fontWeight: 700, fontSize: 14, padding: '12px 24px', borderRadius: 8, border: 'none', cursor: 'pointer', opacity: submitting ? 0.6 : 1 }}>
                            {submitting ? 'Traitement...' : 'Confirmer le désabonnement'}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
